module.exports = __webpack_public_path__ + "img/img.e20be0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img.png
// module id = UBpp
// module chunks = 2